var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-currents-banner"},[_c('div',{staticClass:"color-currents-banner__container"},[_c('span',{staticClass:"color-currents-banner__bold"},[_vm._v("Discover Color Currents: ")]),_c('span',{staticClass:"color-currents-banner__regular"},[_vm._v("a thoughtfully curated, painted palette of new, captivating hues.")])])])
}]

export { render, staticRenderFns }